import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,reorderArray } from 'ionic-angular';

import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { EditmanifestoPage } from '../../pages/editmanifesto/editmanifesto';
import { AddmanifestoPage } from '../../pages/addmanifesto/addmanifesto';

import { SERVER_URL } from "../../config";



@Component({

  selector: 'page-manifesti',

  templateUrl: 'manifesti.html'

})

export class ManifestiPage {

  manifesti;
  errorMessage;
  link;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,

  ) {
   
    this.link = SERVER_URL + "/manifesti/files/"

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UploadPage');

  }
  ionViewWillEnter() {
    console.log('ionViewWillEnter UploadPage');
   
    this.getManifesti();
  }
  getManifesti() {
    this.rest.getManifesti().subscribe(
      manifesti =>{
        this.manifesti = manifesti;
       // alert(JSON.stringify(manifesti))
      },
      error => this.errorMessage = <any>error);
  }
  selManifesto(manifesto) {
    console.log("selManifesto");
    this.navCtrl.push(EditmanifestoPage, { manifesto: manifesto });

  }
  openAddmanifestoPage(){
    this.navCtrl.push(AddmanifestoPage);

  }
  reorderItems(indexes) {
    console.log("reorderItems:" + JSON.stringify(indexes));

    this.manifesti = reorderArray(this.manifesti, indexes);


    console.log("reorderItems list:" + JSON.stringify(this.manifesti));
    var i = 0;
    this.manifesti.forEach(function (element) {

      console.log(element["priority"]);
      element["priority"] = i;
      i++;
    });
    console.log("reorderItems list durante:" + JSON.stringify(this.manifesti));



    this.rest.aggiornaListManifesto(this.manifesti);

  }

}


// WEBPACK FOOTER //
// ./src/pages/manifesti/manifesti.ts